import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { fetchAdminSubmissions } from '../api';
import useNoIndex from '../hooks/useNoIndex';

export default function Admin() {
  useNoIndex();
  const [submissions, setSubmissions] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchAdminSubmissions()
      .then(setSubmissions)
      .catch((err) => {
        if (err?.response?.status === 401) {
          setError('Authentication cancelled or invalid.');
        } else {
          setError(err?.message || 'Could not load submissions.');
        }
      });
  }, []);

  return (
    <div className="page page--wide">
      <div className="admin-toolbar">
        <span />
        <Link to="/admin/questionnaires">Manage questionnaires →</Link>
      </div>

      <h1>Submissions</h1>
      <p className="muted small">Password-protected. Sorted newest first.</p>

      {error && <div className="error">{error}</div>}

      {!submissions && !error && <p className="muted">Loading…</p>}

      {submissions && submissions.length === 0 && (
        <p className="muted">No submissions yet.</p>
      )}

      {submissions && submissions.length > 0 && (
        <div className="card" style={{ padding: 0, overflowX: 'auto' }}>
          <table>
            <thead>
              <tr>
                <th>Date</th>
                <th>Email</th>
                <th>Questionnaire</th>
                <th>Score</th>
                <th>Tier</th>
                <th>Industry</th>
                <th>Size</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {submissions.map((s) => (
                <tr key={s.token}>
                  <td>{new Date(s.createdAt).toLocaleString()}</td>
                  <td>{s.email}</td>
                  <td>{s.questionnaireSnapshot?.title || s.questionnaireSlug || '—'}</td>
                  <td><strong>{s.score}</strong></td>
                  <td>{s.tier}</td>
                  <td>{s.context?.industry || '—'}</td>
                  <td>{s.context?.employees || '—'}</td>
                  <td>
                    <Link to={`/admin/submissions/${s.token}`}>Answers</Link>
                    {' · '}
                    <Link to={`/results/${s.token}`}>Result</Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
